var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tip"},[_c('img',{attrs:{"src":require("../../../assets/images/global/auth-success.png"),"alt":""}}),_c('p',{staticClass:"suText"},[_vm._v("认证通过")])])
}]

export { render, staticRenderFns }